import { appApi } from 'api';
import user from './user';
import tunnel from './tunnel';
import appNotification from './appNotification';
import google from './google';
import customTunnel, { customTunnelReducerCleared } from './customTunnel';
import { environments } from 'utils/constants';
import menu from './menu';

export const createLoggerMiddleware = () => api => next => action => {
    if (action.type === 'location/locationChanged') {
        api.dispatch(customTunnelReducerCleared());
    }
    if (action.error && process.env.NODE_ENV === environments.DEV) {
        if (action.error && action.type !== 'appApi/executeQuery/rejected') {
            console.log(`ERROR - ${action.type}`);
            console.warn(action.error?.message || action.error);
        } else if (action.type.includes('/rejected')) {
            console.warn(
                `${action.error.message} - ${action.meta.arg.endpointName}- ${action.payload}`
            );
        }
    }
    return next(action);
};

const rootReducer = {
    [appApi.reducerPath]: appApi.reducer,
    user,
    tunnel,
    appNotification,
    google,
    customTunnel,
    menu,
};

export default rootReducer;

export { selectors as userSelectors } from './user';
export { selectors as tunnelSelectors } from './tunnel';
export { selectors as appNotificationSelectors } from './appNotification';
export { selectors as googleSelectors } from './google';
export { selectors as customTunnelSelectors } from './customTunnel';
export { selectors as menuSelectors } from './menu';
